import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { HorizontalNav } from './HorizontalNav'
import { useNavigationStore } from '../../stores/navigationStore'
import { cn } from '../../lib/utils'

interface LayoutProps {
  className?: string
}

export const Layout = ({ className }: LayoutProps) => {
  const { navigationStyle } = useNavigationStore()

  if (navigationStyle === 'horizontal') {
    return (
      <div className={cn("h-screen bg-gray-50 dark:bg-gray-900 transition-colors overflow-hidden flex flex-col", className)}>
        <Header />
        <HorizontalNav />
        <main className="flex-1 overflow-auto bg-gray-50 dark:bg-gray-900">
          <div className="p-6">
            <Outlet />
          </div>
        </main>
      </div>
    )
  }

  return (
    <div className={cn("h-screen bg-gray-50 dark:bg-gray-900 transition-colors overflow-hidden", className)}>
      <div className="flex h-full">
        <Sidebar />
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          <Header />
          <main className="flex-1 overflow-auto bg-gray-50 dark:bg-gray-900">
            <div className="p-6">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}